<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" epub:type="epigraph" id="epigraph">
<div class="text" id="epigraph-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center epigraph-content"><i>“Love is composed of a single soul inhabiting two bodies.”</i></p>
<p class="alignment-block-content alignment-block-content-center epigraph-content"><i>–Aristotle</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?65586efc